import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { GridModule,  ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';


import { Vieweligibility271Component } from './vieweligibility271.component';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
  declarations: [
    Vieweligibility271Component
  ],
  imports: [
    CommonModule,
    GridModule,
    MaskedTextBoxModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    PDFExportModule,
    PdfViewerModule,
  ],
  providers: [
    ColumnChooserService,
    PageService,
    SortService,
    FilterService,
    ResizeService
  ],
  exports: [
    Vieweligibility271Component
  ]
})
export class Vieweligibility271Module { }
